<script setup lang="ts">
import { Loader2, Lock } from 'lucide-vue-next'
interface RewardProps {
  badgeText?: string
  buttonBgColor?: string
  buttonText?: string
  buttonTextColor?: string
  img?: string
  isClickable?: boolean
  isProcessing?: boolean
  overlayText?: string | null
  title: string
}

withDefaults(defineProps<RewardProps>(), {
  badgeText: '',
  buttonBgColor: '',
  buttonText: '',
  buttonTextColor: '',
  img: '',
  isClickable: true,
  isProcessing: false,
  overlayText: ''
})

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'click-button'): void
}>()

const handleClick = () => {
  emit('click')
}

const handleButtonClick = () => {
  emit('click-button')
}
</script>

<template>
  <Card
    class="w-full gap-0 overflow-hidden rounded-xl border-0 py-0 shadow-lg"
    :class="isClickable ? 'cursor-pointer' : 'pointer-events-none'"
    @click.stop="handleClick"
  >
    <div class="relative h-[106px] w-full">
      <img v-if="img" :src="img" :alt="title" class="h-[106px] w-full object-cover" />
      <div v-else class="block h-full w-full bg-stone-200" />

      <div v-if="overlayText" class="absolute left-0 top-0 z-10 h-full w-full bg-black/60">
        <div class="flex h-full flex-col items-center justify-center gap-3">
          <Lock class="h-5 w-5 text-white" />
          <p class="text-center text-sm font-bold text-white">
            {{ overlayText }}
          </p>
        </div>
      </div>

      <Badge
        v-if="badgeText"
        variant="secondary"
        class="absolute right-2 top-2 min-w-[30px] justify-center rounded-full border bg-muted text-sm font-bold text-foreground"
      >
        {{ badgeText }}
      </Badge>
    </div>

    <div class="flex flex-col items-center justify-center gap-3 p-3">
      <h3 v-if="title" class="flex items-center justify-center text-center text-sm font-bold">
        {{ title }}
      </h3>

      <div v-if="buttonText" class="text-center">
        <Button
          variant="default-primary"
          class="rounded-full py-1 font-bold shadow-sm"
          :style="
            buttonBgColor ? `color: ${buttonTextColor}!important; background-color: ${buttonBgColor}!important;` : ''
          "
          :disabled="!isClickable || isProcessing"
          @click.stop="handleButtonClick"
        >
          <Loader2 v-if="isProcessing" class="animate-spin" />
          {{ buttonText }}
        </Button>
      </div>
    </div>
  </Card>
</template>
